import * as ApiManager from './_manager'

export const company = {

    list: (payload) => {
        return ApiManager.callApi('/member/company/list', payload);
    }
}
